/* ============================================================
   PROTECCIÓN CONTRA DAÑOS · lógica del carrito
   Ruta sugerida:  assets/damage-protection.js

   Qué hace:
     · Las casillas vienen marcadas por defecto (lo decide el Liquid).
     · Guarda en localStorage qué líneas el cliente DESMARCA.
     · Mantiene en el carrito tantas unidades del producto de
       protección como líneas marcadas haya (1 por línea de joya).
     · Oculta la fila del producto de protección en el carrito.
     · Abre/cierra el modal "¿Qué cubre?".
     · Se re-aplica solo cuando el tema vuelve a renderizar el
       carrito (cambios de cantidad, drawer que se inyecta, etc.).

   Nota: el importe de la protección SÍ entra en el subtotal y en
   el total del checkout (es una línea real del carrito). Solo se
   oculta su fila visible.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.DamageProtectionConfig || {};
  var VARIANT_ID = String(cfg.variantId == null ? '' : cfg.variantId);
  var HANDLE = cfg.productHandle || '';
  var STORAGE_KEY = 'dp_unchecked_lines_v1';
  var SECTION_NAMES = ['main-cart-items', 'main-cart-footer', 'cart-drawer', 'cart-icon-bubble'];
  var MAX_FAILURES = 3;

  var busy = false;
  var pending = false;
  var failures = 0;
  var debounceTimer = null;
  var mo = null;
  var observed = new WeakSet();

  /* ----------------------- localStorage ----------------------- */
  function getOff() {
    try {
      var v = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function setOff(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function turnOff(key) {
    var off = getOff();
    if (off.indexOf(key) === -1) { off.push(key); setOff(off); }
  }
  function turnOn(key) {
    setOff(getOff().filter(function (k) { return k !== key; }));
  }

  /* ----------------------- casillas ----------------------- */
  function boxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-dp-checkbox]'));
  }
  // Líneas distintas (la página de carrito y el drawer pueden mostrar
  // la misma línea a la vez; nos quedamos con claves únicas).
  function eligibleKeys() {
    var set = {};
    boxes().forEach(function (cb) {
      set[cb.getAttribute('data-dp-key')] = true;
    });
    return Object.keys(set);
  }
  function desiredQty() {
    var off = getOff();
    return eligibleKeys().filter(function (k) { return off.indexOf(k) === -1; }).length;
  }
  function paintBoxes() {
    var off = getOff();
    boxes().forEach(function (cb) {
      var key = cb.getAttribute('data-dp-key');
      var on = off.indexOf(key) === -1;
      cb.checked = on;
      var row = cb.closest('[data-dp-row]');
      if (row) { row.classList.toggle('dp-row--off', !on); }
    });
  }

  /* ----------- ocultar la fila del producto de protección ----------- */
  function hideProtectionRows() {
    if (!HANDLE) { return; }
    var links = document.querySelectorAll('a[href*="/products/' + HANDLE + '"]');
    Array.prototype.forEach.call(links, function (a) {
      var row = a.closest('.cart-item, tr.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');
      if (row) { row.style.display = 'none'; }
    });
  }

  /* ----------------------- secciones ----------------------- */
  function replaceInner(liveSelector, parsedDoc, parsedSelector) {
    var live = document.querySelector(liveSelector);
    if (!live) { return; }
    var incoming = parsedDoc.querySelector(parsedSelector);
    if (!incoming) { return; }
    live.innerHTML = incoming.innerHTML;
  }
  function applySections(sections) {
    if (!sections) { return; }
    var parse = function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    };
    if (sections['main-cart-items']) {
      replaceInner('#main-cart-items .js-contents', parse(sections['main-cart-items']), '.js-contents');
    }
    if (sections['main-cart-footer']) {
      replaceInner('#main-cart-footer .js-contents', parse(sections['main-cart-footer']), '.js-contents');
    }
    if (sections['cart-drawer']) {
      replaceInner('#CartDrawer', parse(sections['cart-drawer']), '#CartDrawer');
    }
    if (sections['cart-icon-bubble']) {
      replaceInner('#cart-icon-bubble', parse(sections['cart-icon-bubble']), '#cart-icon-bubble');
    }
  }

  /* ----------------------- API del carrito ----------------------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function postCart(url, body) {
    body.sections = SECTION_NAMES;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ----------------------- reconciliar ----------------------- */
  function finish() {
    busy = false;
    if (pending) { pending = false; reconcile(); }
  }

  function reconcile() {
    if (failures >= MAX_FAILURES) { return; }
    if (busy) { pending = true; return; }
    if (!VARIANT_ID) { return; }
    busy = true;

    getCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var line = null;
      for (var i = 0; i < items.length; i++) {
        if (Number(items[i].variant_id) === Number(VARIANT_ID)) { line = items[i]; break; }
      }
      var desired = desiredQty();
      var current = line ? line.quantity : 0;

      if (desired === current) {
        paintBoxes();
        hideProtectionRows();
        finish();
        return;
      }

      var req;
      if (line) {
        req = postCart('/cart/change.js', { id: line.key, quantity: desired });
      } else if (desired > 0) {
        req = postCart('/cart/add.js', { items: [{ id: Number(VARIANT_ID), quantity: desired }] });
      } else {
        paintBoxes();
        hideProtectionRows();
        finish();
        return;
      }

      req.then(function (data) {
        if (data && data.sections) {
          applySections(data.sections);
          paintBoxes();
          hideProtectionRows();
          notify();
          failures = 0;
        } else {
          // El producto no se pudo añadir/ajustar (p. ej. sin stock).
          failures++;
          paintBoxes();
          hideProtectionRows();
        }
        finish();
      }).catch(function () {
        failures++;
        finish();
      });
    }).catch(function () {
      failures++;
      finish();
    });
  }

  function notify() {
    try { document.dispatchEvent(new CustomEvent('dp:updated')); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }

  /* ----------------------- modal ----------------------- */
  function openModal() {
    var m = document.getElementById('dp-modal');
    if (!m) { return; }
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    var m = document.getElementById('dp-modal');
    if (!m) { return; }
    m.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ----------------------- eventos ----------------------- */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-dp-checkbox]');
    if (!cb) { return; }
    var key = cb.getAttribute('data-dp-key');
    if (cb.checked) { turnOn(key); } else { turnOff(key); }
    paintBoxes();
    reconcile();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-dp-open]')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest && e.target.closest('[data-dp-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); }
  });

  /* ----------------------- observar el carrito ----------------------- */
  function sync() {
    paintBoxes();
    hideProtectionRows();
    reconcile();
  }
  function scheduleSync() {
    if (busy) { return; }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 150);
  }
  function observe() {
    if (!mo) {
      mo = new MutationObserver(function () { scheduleSync(); });
    }
    ['#main-cart-items', '#CartDrawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !observed.has(el)) {
        observed.add(el);
        mo.observe(el, { childList: true, subtree: true });
      }
    });
  }

  /* ----------------------- init ----------------------- */
  function init() {
    if (!VARIANT_ID) { return; }
    paintBoxes();
    hideProtectionRows();
    observe();
    reconcile();
    // El drawer puede inyectarse algo más tarde.
    setTimeout(observe, 1500);
    setTimeout(hideProtectionRows, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();